import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ConfiguredEventDocumentLocation, EventType } from '../../../../../../../../models/event-type';
import { LocationService } from '../../../../../../../../services/location/location.service';
import { DocumentTemplateService } from '../../../../../../../../services/document-template/document-template.service';
import { DocumentTemplate, DocumentType } from '../../../../../../../../models/document-template';
import { CapitanLocation } from '../../../../../../../../models/location';


@Component({
  selector: 'app-add-event-type-required-waiver-modal',
  templateUrl: './add-event-type-required-waiver.component.html',
  styleUrls: ['./add-event-type-required-waiver.component.css']
})
export class AddEventTypeRequiredWaiverComponent implements OnInit {
  @Input() eventType: EventType;
  @Input() submittedCallback: () => undefined;

  public selectedDocumentTemplate: DocumentTemplate = null;
  public selectedLocationIds: number[] = [];

  public documentTemplates: DocumentTemplate[];
  public locations: CapitanLocation[];

  public loadingDocumentTemplates = false;
  public serverError: number = null;

  constructor(
    public locationService: LocationService,
    public documentTemplateService: DocumentTemplateService,
    public activeModal: NgbActiveModal,
  ) {}

  ngOnInit() {
    this.loadDocumentTemplates();
    this.locations = this.locationService.getLocations();
  }

  public toggleLocationId(locationId: number) {
    if (this.selectedLocationIds.includes(locationId)) {
      this.selectedLocationIds.splice(this.selectedLocationIds.indexOf(locationId), 1);
    } else {
      this.selectedLocationIds.push(locationId);
    }
  }

  public handleSubmit() {
    this.updateEventTypePerSelections();
    this.cleanRequiredWaivers();
    this.submittedCallback();
    this.activeModal.close();
  }

  private loadDocumentTemplates() {
    this.loadingDocumentTemplates = true;

    this.documentTemplateService
      .getDocumentTemplates(1, 3000)
      .then(result => {
        this.documentTemplates = result.results.filter(
          dt => {
            return (
              (dt.document_type === DocumentType.waiver) ||
              (
                (dt.document_type === DocumentType.supervisorForm) &&
                (dt.counts_as_waiver_for_supervisees)
              )
            );
          }
        );
        if (this.documentTemplates.length > 0) {
          this.selectedDocumentTemplate = this.documentTemplates[0];
        }
      })
      .catch(reason => {
        this.serverError = reason.status;
      })
      .finally(() => { this.loadingDocumentTemplates = false; });
  }

  private updateEventTypePerSelections() {
    if (this.selectedDocumentTemplate === null) {
      return;
    }
    if (this.selectedLocationIds.length === 0) {
      return;
    }

    const newLocationList: ConfiguredEventDocumentLocation[] = [];
    let matchesExistingTemplate = false;

    for (const pad of this.eventType.required_waiver_documents) {
      if (pad.id === this.selectedDocumentTemplate.id) {
        const existingLocIds = pad.locations.map(locItem => locItem.id);

        for (const loc of this.locations) {
          if (this.selectedLocationIds.includes(loc.id) || existingLocIds.includes(loc.id)) {
            newLocationList.push({ id: loc.id, name: loc.name });
          }
        }

        pad.locations = newLocationList;
        matchesExistingTemplate = true;
      } else {
        // Remove any selected locations from other document templates.
        pad.locations = pad.locations.filter(
          loc => !this.selectedLocationIds.includes(loc.id)
        );
      }
    }

    if (matchesExistingTemplate) { return; }

    for (const loc of this.locations) {
      if (this.selectedLocationIds.includes(loc.id)) {
        newLocationList.push({ id: loc.id, name: loc.name });
      }
    }

    this.eventType.required_waiver_documents.push({
      id: this.selectedDocumentTemplate.id,
      name: this.selectedDocumentTemplate.name,
      locations: newLocationList
    });
  }

  private cleanRequiredWaivers() {
    this.eventType.required_waiver_documents = this.eventType.required_waiver_documents
      .filter(pad => pad.locations.length > 0)
      .sort((pad1, pad2) => pad1.name.localeCompare(pad2.name));
  }
}
